import React from 'react'
import List from '@mui/material/List'
import ListItemText from '@mui/material/ListItemText'
import WebOutlined from '@mui/icons-material/WebOutlined'
import { useTranslation } from 'react-i18next'

import ListItemButton from 'components/Sidebar/Styled/Button'
import ListItemIcon from 'components/Sidebar/Styled/ListItemIcon'
import SubMenu from 'components/Sidebar/Menu/SubMenu'
import { ProjectProps } from 'types/Sidebar'
import bluehavenDomain from 'lib/utility/BluehavenDomain'
import { customStyles } from 'components/Sidebar/Styled/CustomStyles'
import { renderIfAllowedWithElse } from 'lib/authorization/DashboardAccess'

const Projects = ({
  handleDropdownCollapse,
  isDrawerVisible,
}: ProjectProps) => {
  const { t } = useTranslation()
  const tagComponent = (
    <SubMenu
      dataTestId="project"
      keyItem="project"
      name="projects"
      isDrawerVisible={isDrawerVisible}
      handleDropdownCollapse={handleDropdownCollapse}
    >
      <List component="div" disablePadding>
        <ListItemButton
          component="a"
          href={`${bluehavenDomain()}/admin/projects`}
          key="Projects"
          data-testid="projects"
          sx={customStyles.listItemButton}
        >
          <ListItemText primary={t('sidebar.projects')} />
        </ListItemButton>
        <ListItemButton
          component="a"
          href={`${bluehavenDomain()}/admin/project_tags`}
          key="tag-manager"
          data-testid="project-tags"
          sx={customStyles.listItemButton}
        >
          <ListItemText primary={t('sidebar.projectTags')} />
        </ListItemButton>
      </List>
    </SubMenu>
  )

  const projectComponent = (
    <ListItemButton
      component="a"
      href={`${bluehavenDomain()}/admin/projects`}
      key="projects"
      data-testid="projects"
    >
      <ListItemIcon>
        <WebOutlined />
      </ListItemIcon>
      <ListItemText primary={t('sidebar.projects')} />
    </ListItemButton>
  )

  return (
    <>
      {renderIfAllowedWithElse('tag manager', tagComponent, projectComponent)}
    </>
  )
}

export default Projects
